module.exports = __webpack_public_path__ + "img/album-entry.f4ed8f43.svg";